import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport is below the given breakpoint (default: 640 px = Tailwind sm).
 * Re-evaluates on window resize.
 */
export function useIsMobile(breakpoint = 640) {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
    });

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const handler = (e) => setIsMobile(e.matches);
        mql.addEventListener?.('change', handler);
        // Fallback pour navigateurs anciens
        mql.addListener?.(handler);
        return () => {
            mql.removeEventListener?.('change', handler);
            mql.removeListener?.(handler);
        };
    }, [breakpoint]);

    return isMobile;
}
